import { render, staticRenderFns } from "./CNumberColumn.vue?vue&type=template&id=678c4b02"
import script from "./CNumberColumn.vue?vue&type=script&lang=js"
export * from "./CNumberColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678c4b02')) {
      api.createRecord('678c4b02', component.options)
    } else {
      api.reload('678c4b02', component.options)
    }
    module.hot.accept("./CNumberColumn.vue?vue&type=template&id=678c4b02", function () {
      api.rerender('678c4b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CNumberColumn.vue"
export default component.exports